export const PARTICIPANT_STEPS = [
  {
    id: '3e78f9af-b258-40ff-90fe-0449f208799f',
    source: {
      id: '839122c3-fe73-448a-b874-02e67ad3d552',
      settings: {
        general: {
          description: {
            title: '🚀 Getting Started',
            details:
              '{"blocks":[{"key":"5p2im","text":"❌ What not to eat","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":2,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"8g4nq","text":"Anything with refined sugar is off the table.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"2um4k","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"6r49t","text":"This includes the obvious: no candy, chocolate, desserts or sugar!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"133q3","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"aqgcv","text":"There’s also the less obvious: nearly any sauce, salad dressing or packaged food has sugar in it. Check labels, you’re definitely in for a surprise.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"50ume","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"7o0uj","text":"“Natural” sugars are just a rose by another name. This includes honey, agave sugar, maple syrup or any other form of naturally refined sugar.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"5151k","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"f6tmg","text":"✅ What to eat","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":0,"length":2,"style":"BOLD"}],"entityRanges":[],"data":{}},{"key":"cqi7d","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fpmsp","text":"Anything else!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"dgvq1","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"1v7m2","text":"This isn’t no carb or keto. Feel free to indulge in fresh fruit and nutritious whole-grains.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cqf2n","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"c5uvt","text":"Of course, check with your healthcare provider before making any changes to your diet.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"8pje6","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"6.9.1-alpha.1"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 0 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2020-03-11T16:13:29.396Z',
      updatedAt: '2020-03-11T16:13:29.396Z',
    },
    timeFrame: {
      start: '2020-06-17T21:00:00Z',
      finish: '2020-06-18T21:00:00Z',
    },
    transitions: [{ state: 'PENDING', occurredAt: '2020-06-16T08:53:33.755Z' }],
    dateFrame: { start: '2020-06-18', finish: '2020-06-19' },
  },
  {
    id: 'a9393bde-fa5f-4ad1-b187-35f0a8463927',
    source: {
      id: '6e387c1a-68bb-414d-9252-0f7a63113c18',
      settings: {
        general: {
          description: {
            title: '👀 Daily Accountability',
            details:
              '{"blocks":[{"key":"e9mn5","text":"Did you stay away from sugar today? If so, give yourself a pat on the back.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"eorqa","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cbrmj","text":"Don’t worry if you didn’t. Make a fresh start tomorrow!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"5.1.16"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 0 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2020-03-11T16:14:30.820Z',
      updatedAt: '2020-03-11T16:14:30.820Z',
    },
    timeFrame: {
      start: '2020-06-17T21:00:00Z',
      finish: '2020-06-18T21:00:00Z',
    },
    transitions: [{ state: 'PENDING', occurredAt: '2020-06-16T08:53:33.755Z' }],
    dateFrame: { start: '2020-06-18', finish: '2020-06-19' },
  },
  {
    id: '0d6d15fe-cb92-41c6-aa35-76d4fe86bee6',
    source: {
      id: '0db19035-ed60-4411-b266-4dd3915373a7',
      settings: {
        general: {
          description: {
            title: '👀 Daily Accountability',
            details:
              '{"blocks":[{"key":"e9mn5","text":"Did you stay away from sugar today? If so, give yourself a pat on the back.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"eorqa","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"cbrmj","text":"Don’t worry if you didn’t. Make a fresh start tomorrow!","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"5.1.16"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 1 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2020-03-11T16:46:10.766Z',
      updatedAt: '2020-03-11T16:46:10.766Z',
    },
    timeFrame: {
      start: '2020-06-18T21:00:00Z',
      finish: '2020-06-19T21:00:00Z',
    },
    transitions: [{ state: 'PENDING', occurredAt: '2020-06-16T08:53:33.755Z' }],
    dateFrame: { start: '2020-06-19', finish: '2020-06-20' },
  },
  {
    id: 'cc5b187e-556d-4525-9b8a-7d783e66ab94',
    source: {
      id: '9d6077b9-6e9f-4c8f-8f80-efda198462ab',
      settings: {
        general: {
          description: {
            title: '🧐 What are your triggers?',
            details:
              '{"blocks":[{"key":"890oo","text":"Most of us reach for sweets and sugary snacks because of some trigger.\\n","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"1av54","text":"Pay attention to your cravings and try to pinpoint why you want sugar.","type":"unstyled","depth":0,"inlineStyleRanges":[{"offset":51,"length":3,"style":"ITALIC"}],"entityRanges":[],"data":{}},{"key":"btfl2","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"doabo","text":"Are you stressed? Go for a walk, meditate or find another way to unwind.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"ekp1f","text":"","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}},{"key":"fk8oh","text":"Are you truly hungry? Grab a healthy snack: nuts, fruit or even a full meal.","type":"unstyled","depth":0,"inlineStyleRanges":[],"entityRanges":[],"data":{}}],"entityMap":{},"VERSION":"5.1.16"}',
          },
          duration: { unit: 'DAYS', value: 1 },
          recurrenceSettings: { schedules: [] },
        },
        embedding: {
          startConditions: [
            {
              dependency: { container: {} },
              delay: { unit: 'DAYS', value: 1 },
            },
          ],
          isMilestone: false,
        },
      },
      createdAt: '2020-03-11T16:46:18.272Z',
      updatedAt: '2020-03-11T16:46:18.272Z',
    },
    timeFrame: {
      start: '2020-06-18T21:00:00Z',
      finish: '2020-06-19T21:00:00Z',
    },
    transitions: [{ state: 'PENDING', occurredAt: '2020-06-16T08:53:33.755Z' }],
    dateFrame: { start: '2020-06-19', finish: '2020-06-20' },
  },
];
